import mapDoc from 'utils/cms/mapDoc';
import mapFooter from 'utils/cms/mapFooter';
import mapGallery from 'utils/cms/mapGallery';
import mapHeader from 'utils/cms/mapHeader';
import mapHome from 'utils/cms/mapHome';
import mapHomeEnt from 'utils/cms/mapHomeEnt';
import mapMeta from 'utils/cms/mapMeta';
import mapPreveiwPanel from 'utils/cms/mapPreviewPanel';
import mapShowtimes from 'utils/cms/mapShowtimes';
import mapSynopsis from 'utils/cms/mapSynopsis';
import mapVideos from 'utils/cms/mapVideos';
import mapWatchMore from 'utils/cms/mapWatchMore';

export function mapCmsMovieDataToBoltAppData(cmsData, appData) {
	const showtimesActive = cmsData?.pages?.showtimes?.active;
	const homeEntActive = cmsData?.pages?.homeEnt?.active;

	const result = {
		doc: mapDoc(cmsData, appData),
		footer: mapFooter(cmsData, appData),
		header: mapHeader(cmsData, appData),
		meta: mapMeta(cmsData, appData),
		options: {
			dualView: showtimesActive && homeEntActive,
			forceLive: showtimesActive,
		},
		pages: {
			boltGallery: mapGallery(cmsData, appData),
			boltHome: mapHome(cmsData, appData),
			boltHomeEnt: mapHomeEnt(cmsData, appData),
			boltPreviewPanel: mapPreveiwPanel(cmsData, appData),
			boltShowtimes: mapShowtimes(cmsData, appData),
			boltSynopsis: mapSynopsis(cmsData, appData),
			boltVideos: mapVideos(cmsData, appData),
			boltWatchMore: mapWatchMore(cmsData, appData),
		},
		status: cmsData.status,
	};

	return result;
}
